import React, { useRef, useEffect, useState, useImperativeHandle } from "react";
import { useDispatch } from "react-redux";

import { UploadMedia } from "../../store/apiCalls/profileDetails";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import katex from "katex";
import "katex/dist/katex.min.css";
import "../../containers/autherFlow/personalDetails/PersonalDetails.scss";

const SunRichText = ({
  hide = false,
  style,
  name,
  handleChange,
  uploadedImg,
  value,
  dataId = "",
  manageCiatation,
  refranceRef,
}) => {
  useEffect(() => {
    window.WEBSPELLCHECKER_CONFIG = {
      autoSearch: true,
      autoDestroy: true,
      autocorrect: true,
      autocomplete: true,
      serviceProtocol: "https",
      servicePort: "443",
      serviceHost: "webspellchecker.assessapp.com.au",
      servicePath: "wscservice/api",
      lang: "en_US",
    };

    const script = document.createElement("script");
    script.src =
      "https://webspellchecker.assessapp.com.au:443/wscservice/wscbundle/wscbundle.js";
    script.async = true;

    script.onload = () => {
      // Add custom styles to hide badges, settings, and more actions
      const style = document.createElement("style");
      style.innerHTML = `
      /* Hide toggle & settings icons */
      #my-editor .wsc-badge__item .wsc-icon-toggle,
      #my-editor .wsc-badge__item .wsc-icon-settings,
      .wsc-action-items_list button[title="Settings"],
      .wsc-action-items_list .wsc-icon-settings,
      /* Hide More Actions dropdown and buttons */
      .wsc-action-items_more-actions,
      .wsc-action-items_more-actions-list,
      .wsc-action-items_more-actions-list button {
        display: none !important;
      }

      #my-editor [class*=" wsc-icon-"] {
        font-family: 'wscicomoon' !important;
        font-size: 24px !important;
      }
      #my-editor .wsc-badge--small:not(:hover):not(.wsc-badge--focused) {
        width: 8px !important;
        height: 8px !important;
        overflow: hidden !important;
      }
      #my-editor .wsc-badge--small:not(:hover):not(.wsc-badge--focused) .wsc-badge__label-button {
        width: 8px !important;
        height: 8px !important;
      }
      #my-editor .wsc-problem-item__suggestion .wsc-button__text {
        text-transform: none !important;
      }
    `;
      document.head.appendChild(style);

      // MutationObserver to remove dynamically added Settings & More actions buttons
      const observer = new MutationObserver(() => {
        document
          .querySelectorAll(
            'button[title="Settings"], button[title="Disable"], .wsc-icon-settings, .wsc-action-items_more-actions, .wsc-action-items_more-actions-list'
          )
          .forEach((el) => el.remove());
      });

      observer.observe(document.body, { childList: true, subtree: true });

      // Save observer for cleanup
      script._observer = observer;
    };

    document.body.appendChild(script);

    return () => {
      if (script._observer) script._observer.disconnect();
      document.body.removeChild(script);
    };
  }, []);

  const dispatch = useDispatch();
  const editor = useRef();
  const getSunEditorInstance = (sunEditor) => {
    editor.current = sunEditor;
  };
  useImperativeHandle(refranceRef, () => ({
    citationInRefrance(details) {
      editor.current.insertHTML(details, false, true, false);
    },
    getEditorContent() {
      return editor.current.getContents();
    },
  }));
  useEffect(() => {}, []);

  function onChange(content) {
    handleChange(content, "added");
  }

  function handleImageUploadBefore(files, info, uploadHandler) {
    uploadHandler(files, info);
  }
  const escapeRegExpMatch = function (s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  };
  const isExactMatch = (str, match) => {
    return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str);
  };
  async function handleImageUpload(
    targetImgElement,
    index,
    state,
    imageInfo,
    remainingFilesCount
  ) {
    if (imageInfo && isExactMatch(imageInfo.src, "base64")) {
      try {
        const fileForm = dataURLtoFile(imageInfo.src, imageInfo.name);

        dispatch({ type: "SET_LOADER", payload: true });
        const formData = new FormData();
        let reader = new FileReader();
        formData.append("file", fileForm);

        const uploadResp = await UploadMedia(formData);
        if (uploadResp.status === 200) {
          targetImgElement.src = uploadResp.data.url;
          uploadedImg(uploadResp.data.url);
          handleChange(editor.current.getContents(), "added");
        } else {
          alert("s3 bucket upload error");
        }
        dispatch({ type: "SET_LOADER", payload: false });
      } catch (err) {
        dispatch({ type: "SET_LOADER", payload: false });
      }
    } else if (imageInfo) {
      targetImgElement.src = imageInfo.src;
      uploadedImg(imageInfo.src);
    } else if (imageInfo === null) {
      handleChange(editor.current.getContents(), "removeImg");
    }
  }

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = window.atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  function onKeyUp(e) {}

  function getMenuList() {
    const button = [
      "undo", // we can delete the button from ui which we do not need .
      "redo",
      // "font",
      // "fontSize",
      //"formatBlock",
      //"paragraphStyle",
      "blockquote",
      "bold",
      "underline", // we can delete the button from ui which we do not need .
      "italic",
      "strike",
      "subscript",
      "superscript",
      "fontColor",
      // "hiliteColor",
      // "textStyle",
      //"removeFormat",
      "outdent",
      "indent",
      "align",
      "horizontalRule",
      "list",
      // "lineHeight",
      "table",
      "link",
      "image",
      "fullScreen",
      //"showBlocks",
      // "codeView",
      // "preview",
      //  "print",
      "math",
      // "video",
      // "audio",
      // "imageGallery",
      // "save",
    ];
    if (
      name === "Abstract" ||
      name === "Introduction" ||
      name === "References"
    ) {
      button.splice(18, 1);
    }

    return button;
  }
  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");

    const removeInlineStyles = (element) => {
      return element.textContent; // Return only the text content
    };

    return input;
  }
  function onPaste(event, cleanData, maxCharCount, core) {
    const detail = htmlDecode(cleanData);
    // console.log(detail);

    if (detail.includes("generatedCitation") === true) {
      const splitDetail = detail.split("Extract");
      if (splitDetail.length > 0) {
        editor.current.insertHTML(splitDetail[0], true, true, true);

        manageCiatation(splitDetail[1]);
        return false;
      }
    } else {
      editor.current.insertHTML(detail);
      return false;
    }
  }

  return (
    <div id="my-editor">
      <SunEditor
        setDefaultStyle="font-family: Calibri, sans-serif;"
        getSunEditorInstance={getSunEditorInstance}
        hide={hide}
        lang="en"
        setOptions={{
          katex: katex,
          height: 300,
          charCounter: true,
          charCounterLabel: "character count:",
          buttonList: [getMenuList()],
          font: ["Calibri"], // Only allow Calibri
          attributesWhitelist: {
            all: "style",
          },
          colorList: "#000000",
        }}
        onChange={onChange}
        onImageUploadBefore={handleImageUploadBefore}
        onImageUpload={handleImageUpload}
        setContents={value}
        onPaste={(event, cleanData, maxCharCount, core) => {
          const detail = htmlDecode(cleanData);
          if (detail.includes("generatedCitation")) {
            const splitDetail = detail.split("Extract");
            if (splitDetail.length > 0) {
              editor.current.insertHTML(splitDetail[0], true, true, true);
              manageCiatation(splitDetail[1]);
              return false;
            }
          } else {
            // Clean pasted HTML and enforce Calibri
            const parser = new DOMParser();
            const doc = parser.parseFromString(detail, "text/html");
            doc.body.querySelectorAll("*").forEach((el) => {
              el.style.fontFamily = "Calibri, sans-serif";
            });
            editor.current.insertHTML(doc.body.innerHTML);
            return false;
          }
        }}
      />
    </div>
  );
};
export default SunRichText;
